{
  "NAME": "DirectoryModal",
  "AddDirectoryTitle": "Adicionar diretório",
  "ModifyDirectoryTitle": "Modificar diretório",
  "TelServerFormLabel": "Servidor telefónico",
  "PartitionFormLabel": "Partição",
  "TelNumberFormLabel": "Número de telefone",
  "DescriptionFormLabel": "Descrição",
  "DirectoryAddModify_UnknownOrDeleted": "[Desconhecido ou Suprimido]",
  "DirectoryAddModify_ServerErrorTitle": "Erros de validação",
  "DirectoryAddModify_ValidationWarning": "Certifique-se de que todos os campos estão corretamente preenchidos",
  "DirectoryAddModify_ButtonHelpLabel": "Ajuda?",
  "DirectoryAddModify_ButtonSubmitLabel": "Guardar",
  "DirectoryAddModify_ButtonCancelLabel": "Cancelar",
  "DirectoryAddModify_PromptMessage": "Tem a certeza de que pretende fechar esta janela? Todas as configurações modificadas serão perdidas quando fechadas.",
  "DirectoryAddModify_PromptConfirm": "Sim",
  "DirectoryAddModify_PromptCancel": "Cancelar",
  "TelNumberFormLabel_Validation_Error": "O número de telefone é obrigatório",
  "DescriptionFormLabel_Validation_Error": "A descrição é obrigatória",
  "DirectoryAddModify_TabsDetails": "Detalhes"
}